import React, { useState, useEffect } from "react";
import ConfirmBoxModal from "../../../components/ConfirmBoxModal";
import SaveButton from "../../../components/SaveButton";
import CancelButton from "../../../components/CancelButton";
import { useGetUserPermissionPerField } from "./UsersManagement/hooks/useGetUserPermissionPerField";
import { useRecoilState } from "recoil";
import { formDirty } from "./Atoms/atoms";
import { useGetRolePermissions } from "./RolesManagement/hooks/useGetRolePermissions";
import { toast } from "../../../components/toastNotification";
import CustomLoader from "../../../components/CustomLoader";
import { useUpdateRolePermission } from "./RolesManagement/hooks/useUpdateRolePermission";
import { useAddRoleData } from "./RolesManagement/hooks/useAddRoleData";
import TextInput from "../../../components/TextInput";
import { useQueryClient } from "react-query";
import { useUpdateRoleData } from "./RolesManagement/hooks/useUpdateRoleData";
import PermissionField from "./Permission/PermissionField";
import PermissionRoles from "./Permission/PermissionRoles";
import { PermissionChanged, UpdateRole } from "./types";
export const Permission = ({
  id = 0,
  permissionType,
  setEditPermissions,
  isForAddingRole,
  rowData,
  setEditRoleData,
  handleSaveEdit,
}) => {
  const queryClient = useQueryClient();

  const { data: roleActivePermissions, isLoading: getRoleLoading } =
    useGetRolePermissions(id, permissionType === "role");

  const datas = useGetUserPermissionPerField(id);

  const [permissionPerField, setPermissionsPerField] = useState([]);

  useEffect(() => {
    if (datas && datas?.data?.length >= 0 && permissionPerField.length === 0) {
      setPermissionsPerField(datas.data);
    }
  }, [datas.data, permissionPerField.length]);

  const [newRolePermissionData, setNewRolePermissionData] = useState({
    roleName: "",
    isActive: false,
    rolePermissions: [] as UpdateRole[],
  });

  const [roleData, setRoleData] = useState<UpdateRole[]>([]);

  const [newData, setNewData] = useState(isForAddingRole ? [] : rowData);

  const {
    mutate: AddRole,
    data: AddRes,
    isSuccess: addSuccess,
    reset: resetAdd,
  } = useAddRoleData();

  const [updateUser, setUpdateUser] = useState(false);
  const {
    mutate: UpdateRolePermissions,
    data: updateRes,
    isSuccess: updateSuccess,
    reset: resetUpdate,
  } = useUpdateRolePermission();

  const { mutateAsync: updateRoleData } = useUpdateRoleData();

  const Update = async () => {
    if (isForAddingRole) {
      AddRole(newRolePermissionData);
    } else {
      const res = await updateRoleData(newData);
      if (res === "Duplicate") {
        setUpdateUser(false);
        setEditPermissions(false);
      } else {
        UpdateRolePermissions(roleData);
        handleSaveEdit();
      }
    }
  };
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let datasChanged: PermissionChanged[] = [];

    if (!getRoleLoading) {
      roleActivePermissions.forEach((subModule) => {
        datasChanged.push({ moduleName: subModule.name, changed: false });
      });
      if (datasChanged.length === roleActivePermissions.length) {
        setLoading(true);
      }
    }
  }, [roleActivePermissions, getRoleLoading]);

  const [dirty, setDirty] = useRecoilState(formDirty);

  useEffect(() => {
    setDirty(false);
  }, []);

  if (getRoleLoading) {
    return <CustomLoader />;
  }

  if (addSuccess && AddRes) {
    if (AddRes.status === 201 || AddRes.status === 200) {
      if (AddRes.data === "Duplicate") {
        toast.fire("Failed", "Role already exist", "warning");
      } else {
        toast.fire("Success", "Role added successfully", "success");
        queryClient.invalidateQueries("GetRolesWithUsers");
        queryClient.invalidateQueries("RoleActivePermissions");
        queryClient.invalidateQueries("RolePermissionFields");

        setNewRolePermissionData({
          roleName: newData.roleName,
          isActive: false,

          rolePermissions: roleData,
        });
      }
      setUpdateUser(false);

      setEditPermissions(false);
    } else if (AddRes.status === 500) {
      if (
        AddRes.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        AddRes.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Role were successfully added, but " + AddRes.data.message,
          "warning"
        );
      } else {
        toast.fire(
          "Adding of Role failed",
          "Server Error: Cannot add Role",
          "error"
        );
      }
      queryClient.invalidateQueries("GetRolesWithUsers");
      queryClient.invalidateQueries("RoleActivePermissions");
      queryClient.invalidateQueries("RolePermissionFields");

      setNewRolePermissionData({
        roleName: newData.roleName,
        isActive: false,

        rolePermissions: roleData,
      });

      setUpdateUser(false);
      setEditPermissions(false);
    } else {
      toast.fire(
        "Adding of Role failed",
        "Server Error: Cannotaa add Role",
        "error"
      );
      queryClient.invalidateQueries("GetRolesWithUsers");
      queryClient.invalidateQueries("RoleActivePermissions");
      queryClient.invalidateQueries("RolePermissionFields");
    }
    resetAdd();
  }

  if (updateSuccess && updateRes) {
    if (updateRes.status === 201 || updateRes.status === 200) {
      toast.fire("Success", "Role updated successfully", "success");
      queryClient.invalidateQueries("GetRolesWithUsers");
      queryClient.invalidateQueries("RoleActivePermissions");
      queryClient.invalidateQueries("RolePermissionFields");

      setNewRolePermissionData({
        roleName: newData.roleName,
        isActive: false,

        rolePermissions: roleData,
      });

      setUpdateUser(false);
      setEditPermissions(false);
    } else if (updateRes.status === 500) {
      if (
        updateRes.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available" ||
        updateRes.data.message ===
          "Service not available, closing transmission channel. The server response was: 4.3.2 Service not available"
      ) {
        toast.fire(
          "Warning",
          "Role were successfully updated, but " + updateRes.data.message,
          "warning"
        );
      } else {
        toast.fire(
          "Updating of Role failed",
          "Server Error: Cannot updated Role",
          "error"
        );
      }
      queryClient.invalidateQueries("GetRolesWithUsers");
      queryClient.invalidateQueries("RoleActivePermissions");
      queryClient.invalidateQueries("RolePermissionFields");

      setNewRolePermissionData({
        roleName: newData.roleName,
        isActive: false,

        rolePermissions: roleData,
      });

      setUpdateUser(false);
      setEditPermissions(false);
    } else {
      toast.fire(
        "Updating of Role failed",
        "Server Error: Cannot update Role",
        "error"
      );
      queryClient.invalidateQueries("GetRolesWithUsers");
      queryClient.invalidateQueries("RoleActivePermissions");
      queryClient.invalidateQueries("RolePermissionFields");
    }
    resetUpdate();
  }

  const roleNameSubmit = newData.roleName;
  const handleSubmit = () => {
    if (isForAddingRole) {
      const newData = roleNameSubmit;

      setNewRolePermissionData({
        roleName: newData,
        isActive: true,
        rolePermissions: roleData,
      });
    } else {
      const data = newData;

      setNewData({
        ...data,
      });
    }
    setUpdateUser(true);
  };

  const Validation = () => {
    if (isForAddingRole) {
      handleSubmit();
    } else {
      setUpdateUser(true);
    }
  };

  return (
    <div className="w-full  px-4 rounded-md border-primary  box-shadow ">
      <div className="w-full max-w p-2 mx-auto bg-white rounded-2xl">
        <div className="font-bold text-lg text-primary not-italic mr-2 uppercase ">
          Role Details
        </div>
        <div className="animate-fade-in-down flex justify-between mt-2 mb-2 ">
          <div className="flex justify-start items-center gap-2 w-1/2">
            <div>Role Name:</div>
            <div className="w-1/2">
              <TextInput
                value={undefined}
                className="font-normal"
                onChange={(e) => {
                  setDirty(true);
                  if (isForAddingRole) {
                    const data = newRolePermissionData;

                    setNewData({ ...data, roleName: e.target.value });
                  } else {
                    const data = newData;
                    setNewData({ ...data, roleName: e.target.value });
                  }
                }}
                defaultValue={rowData?.roleName}
              />
            </div>

            {!isForAddingRole ? (
              <div className="ml-5">
                Is Active :{""}
                <input
                  type="checkbox"
                  className="text-center h-5 w-5 my-2 px-4"
                  defaultChecked={rowData?.isActive}
                  onChange={(e) => {
                    setDirty(true);
                    const data = newData;
                    setNewData({ ...data, isActive: e.target.checked });
                  }}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
          <div className="flex justify-end items-center gap-2 ">
            <div>
              <SaveButton
                disabled={!dirty}
                buttonText="Save"
                onClick={() => {
                  Validation();
                }}
              />
            </div>
            <div>
              <CancelButton
                className="px-3 py-1 text-xs text-white gap-x-2 bg-btnClose rounded-full flex items-center justify-center font-semibold hover:bg-gray-400 box-shadow"
                onClick={() => {
                  setEditPermissions(false);
                  setEditRoleData([]);

                  setNewRolePermissionData({
                    roleName: newData.roleName,
                    isActive: false,

                    rolePermissions: roleData,
                  });
                }}></CancelButton>
            </div>
          </div>
        </div>

        {loading ? (
          roleActivePermissions.map(
            (d, i) =>
              d.name !== "Field Access" && (
                <div key={i}>
                  <PermissionRoles
                    d={d}
                    i={i}
                    roleData={roleData}
                    setRoleData={setRoleData}
                    id={id}></PermissionRoles>
                </div>
              )
          )
        ) : (
          <CustomLoader />
        )}

        <div className="font-bold text-primary text-lg mt-2 uppercase">
          <span className="font-bold text-primary text-lg mt-2 uppercase">
            Field Access
          </span>
          {Array.isArray(permissionPerField) &&
            permissionPerField.map((data, index) => (
              <div key={index}>
                <PermissionField
                  data={data}
                  index={index}
                  id={id}
                  roleData={roleData}
                  setRoleData={setRoleData}></PermissionField>
              </div>
            ))}
        </div>

        <ConfirmBoxModal
          ModalTitle={
            isForAddingRole ? "Add Role Permission" : "Update Role Permission"
          }
          qConfirmation={`Are you sure you want to ${
            isForAddingRole ? "add" : "update"
          } this?`}
          isOpen={updateUser}
          onClose={() => setUpdateUser(false)}
          onClickFunction={() => {
            Update();
          }}
          cancelButtonRef={() => {}}
        />
      </div>
    </div>
  );
};
